import React, { Fragment } from 'react'

class LoaderItemFeed extends React.Component {

  render() {
    return (
      <Fragment>
        <div className='loader__feed-container'>
          <div className='loader__feed-text'></div>
          <div className='loader__feed-text' style={{ width: '70%' }}></div>
          <div className='loader__feed-button-container'>
            <div className='loader__feed-text' style={{ width: '70%', height: '16px' }}></div>
            <div className='loader__feed-button'></div>
          </div>
          <div className='loader__feed-image'></div>
        </div>
      </Fragment>
    )
  }
}

export default LoaderItemFeed;